import { QuestionState } from '../../constans/question-enums';
import {
  DEFAULT_MAX_INTERVAL,
  DEFAULT_MIN_INTERVAL,
  DEFAULT_STEP,
  INCREMENT,
  INITIAL_VALUE,
  UINT_32_ARRAY_MAX_VALUE
} from '../../constans/prioritize-constants';
import QuestionEntity, { IQuestion, TQuestionEntity } from '../../store/question-store/question-entetiy';
import PollEntity from './../../store/polls-store/poll-entity';

type TDraggableEntity = QuestionEntity | TQuestionEntity | PollEntity;

interface IPrioritizeArg {
   startIndex: number;
   endIndex: number;
   list: TDraggableEntity[];
}

interface ILowestPrioritizeByStateArg {
  list: QuestionEntity[];
  state: QuestionState | string;
}

export const reCalcPrioritize = (firstTarget: TDraggableEntity, secondTarget: TDraggableEntity): number => {
  const firstOrderIndex: number | undefined = firstTarget?.prioritizeIndex;
  const secondIndex: number | undefined = secondTarget?.prioritizeIndex;
  const divider = 2;

  if(!firstTarget) {
    return secondIndex + INCREMENT;
  } else if(!secondTarget) {
    return firstOrderIndex - INCREMENT;
  }

  return firstOrderIndex - ((firstOrderIndex - secondIndex) / divider);
};

export const getNewPrioritizeByDnDMove = (
  source: TQuestionEntity[],
  destination: TQuestionEntity[],
  droppableSourceIndex: number,
  droppableDestinationIndex: number): number => {
  const replacedEl = 0;
  const randomIntFromInterval = saveMathRandom(DEFAULT_MAX_INTERVAL, DEFAULT_MIN_INTERVAL);

  const copyOfSource: TQuestionEntity[] = [...source];
  const copyOfDestination: TQuestionEntity[] = [...destination];
  const lowestElementInSourceList: number = getLowestPrioritizeInList(copyOfSource);

  if(!copyOfDestination.length) {
    return lowestElementInSourceList - randomIntFromInterval;
  }

  const [removed] = copyOfSource.splice(droppableSourceIndex, DEFAULT_STEP);
  copyOfDestination.splice(droppableDestinationIndex, replacedEl, removed);

  return reCalcPrioritize(
    copyOfDestination[droppableDestinationIndex - DEFAULT_STEP],
    copyOfDestination[droppableDestinationIndex + DEFAULT_STEP]
  );

};

export const getNewPrioritize = ({ startIndex, endIndex, list }: IPrioritizeArg): number => {
  const replaceNum = 1;
  const additionalIdx = 1;
  const replacedEl = 0;
  const listCopy = [...list] as TDraggableEntity[];
  const [ removed ] = listCopy.splice(startIndex, replaceNum);
  listCopy.splice(endIndex, replacedEl, removed);

  return reCalcPrioritize(
    listCopy[endIndex - additionalIdx],
    listCopy[endIndex + additionalIdx]
  );
};

export const sortByPrioritize = (array: TDraggableEntity[]): TDraggableEntity[] => {
  return array.sort((firstEl, secondEl) => secondEl.prioritizeIndex - firstEl.prioritizeIndex);
};

export const getHigherPrioritizeByState = ({ list, state }: ILowestPrioritizeByStateArg): number => {
  const listByState: QuestionEntity[] = list.filter((question) => {
    return question.state === state;
  });

  if(listByState.length) {
    const sortedItems = sortByPrioritize(listByState)[0] as QuestionEntity;
    return sortedItems.prioritizeIndex + INCREMENT;
  } else {
    return INITIAL_VALUE;
  }
};

export const getLowestPrioritizeInList = (list: TQuestionEntity[]): number => {
  const prioritize: TQuestionEntity[] = [...list].sort((currentEl, secondEl) => {
    return currentEl.prioritizeIndex - secondEl.prioritizeIndex;
  });
  return prioritize[0] ? prioritize[0].prioritizeIndex : INITIAL_VALUE;
};

export const prioritizeQuestionsInGroup = (list: QuestionEntity[], fullList: TQuestionEntity[], state: QuestionState): IQuestion[] => {
  const lowestPriorityIndex = getLowestPrioritizeInList(fullList);
  const priorList = sortByPrioritize(list) as QuestionEntity[];
  const indexStep = 1;

  return priorList.map((question, index) => {

    question.state = state;
    question.prioritizeIndex = index === 0 ?
      lowestPriorityIndex
      : list[index-indexStep].prioritizeIndex - INCREMENT;
    return question.toDTO();
  });
};

export const splitQuestionGroupChunks = (list:IQuestion[], chunkSize: number):IQuestion[][] => {
  const chunkedQuestionList = [];
  for (let i = 0; i < list.length; i += chunkSize){
    const chunk = list.slice(i, i + chunkSize);
    chunkedQuestionList.push(chunk);
  }
  return chunkedQuestionList;
};

export const reCalcEachItemPrioritizeIndex = (list: TQuestionEntity[], indexValue: number, increment: number): IQuestion[] => {
  let initialValue = indexValue;

  return list.map((question, index) => {
    if(!index) {
      return {
        ...question.toDTO(),
        prioritizeIndex: initialValue
      };
    } else {
      initialValue += increment;
      return {
        ...question.toDTO(),
        prioritizeIndex: initialValue,
      };
    }
  });
};

export const checkDuplicateOfPrioritizeIndexInList = (list: TQuestionEntity[], messageId: string | null, prioritizeIndex: number): boolean => {
  const someCB = (question: TQuestionEntity) => question.messageId !== messageId && question.prioritizeIndex === prioritizeIndex;
  return list.some(someCB);
};

export const saveMathRandom = (maxInterval: number, minInterval: number): number => {
  const uint32Array: Uint32Array = new Uint32Array(DEFAULT_STEP);
  const randomUINT32Array: Uint32Array = window.crypto.getRandomValues(uint32Array);
  return Math.floor(randomUINT32Array[0] / (UINT_32_ARRAY_MAX_VALUE + DEFAULT_STEP) *
      (maxInterval - minInterval + DEFAULT_STEP) + minInterval);
};

